export default {"src":"/_next/static/media/LOPE.465e2ebe.svg","height":18,"width":18};